import LayoutBasic from "@/views/layouts/LayoutBasic";
import StoresStatus from "@/views/stores/Status";
import BranchStores from "@/views/branches/Stores";
import BranchStoreStatus from "@/views/branches/StoreStatus";
import StoreRemainStatus from "@/views/stores/Remain";
import StoreAdjustments from "@/views/stores/StoreAdjustments.vue";
import StoreCorrection from "@/views/stores/Corrections.vue";
import StoreRevision from "@/views/stores/Revision.vue";
import RevisionInvoice from "@/views/stores/RevisionInvoice.vue";
import SendOrders from "@/views/stores/SendOrders.vue";
import RevisionIncomeInvoice from "@/views/stores/RevisionIncomeInvoice.vue";
import GeneralSettings from "@/views/settings/GeneralSettings.vue";
import DrugDimensions from "@/views/stores/drugs/DrugDimensions.vue";
import RevisionInvoiceLight from "@/views/stores/RevisionInvoiceLight.vue";


const routes = {
  path: '/stores',
  component: LayoutBasic, // Change the desired Layout here,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'status/list',
      component: StoreRemainStatus,
      name: 'StoreRemainStatus'
    },
    {
      path: 'status/correction',
      component: StoreCorrection,
      name: 'StoreCorrection'
    },
    {
      path: 'status',
      component: StoresStatus,
      name: 'storesStatus'
    },
    {
      path: 'all',
      name: 'BranchStores',
      component: BranchStores
    },
    {
      path: 'adjustments',
      name: 'StoreAdjustments',
      component: StoreAdjustments
    },
    {
      path: 'revision',
      name: 'StoreRevision',
      component: StoreRevision
    },
    {
      path: 'revInvoice',
      name: 'RevisionInvoice',
      component: RevisionInvoice
    },
    {
      path: 'revInvoiceLight',
      name: 'RevisionInvoiceLight',
      component: RevisionInvoiceLight
    },
    {
      path: 'store/:id',
      name: 'BranchStoreStatus',
      component: BranchStoreStatus
    },
    {
      path: 'postsend',
      name: 'SendOrdersByPost',
      component: SendOrders
    },
    {
      path: 'drugs/dimensions',
      name: 'DrugsDimensions',
      component: DrugDimensions,
      meta: {
        permission: 'store/drugs/dimensions'
      }
    },
    {
      path: 'revision/invoice/income',
      name: 'RevisionIncomeInvoice',
      component: RevisionIncomeInvoice
    },
  ]
}

export default routes;
